import { createFileRoute, notFound } from '@tanstack/react-router'

import { AiSessionDebug } from '@/ai-assistant/components/AiSessionDebug/AiSessionDebug'
import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { PageContainer } from '@/app/manager/Layout'
import { FEATURE_AI_ASSISTANT_DEBUG } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/company/_management/ai-assistant-debug')(
  {
    validateSearch: (
      search: Record<string, unknown>,
    ): { sessionId?: string } => ({
      sessionId:
        typeof search.sessionId === 'string' ? search.sessionId : undefined,
    }),
    head: () => ({
      meta: [{ title: buildPageTitle({ titleValue: 'AI Session Debug' }) }],
    }),
    beforeLoad: ({ context }) => {
      if (!context.user?.features.includes(FEATURE_AI_ASSISTANT_DEBUG)) {
        throw notFound()
      }
    },
    component: RouteComponent,
  },
)

function RouteComponent() {
  const { sessionId } = Route.useSearch()

  return (
    <CompanyPage>
      <PageContainer py="10">
        <AiSessionDebug initialSessionId={sessionId} />
      </PageContainer>
    </CompanyPage>
  )
}
